module.exports = __webpack_public_path__ + "images/application/i-compare-preview-eec55cff.svg";